import { from, ApolloClient, ApolloLink, HttpLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error';

import { cache } from './apolloCache';
import { getAuthHeader } from '../lib/token';
import env from '../lib/env';

const httpLink = new HttpLink({
  uri: `${env.REACT_APP_PALANTIR_URL}/graphql`,
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

const authLink = new ApolloLink(async (operation, forward) => {
  try {
    const authorizationHeader = await getAuthHeader();
    operation.setContext(({ headers }) => ({
      headers: {
        ...headers,
        ...authorizationHeader,
      },
    }));
  } catch (e) {
    if (e === 'no refresh token' || e === 'not authenticated') {
      // No valid token, log and then will redirect to login
      console.log('[Auth error]:', e);
    } else {
      throw e;
    }
  }
  return forward(operation);
});

const omitTypenameLink = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    operation.variables = JSON.parse(
      JSON.stringify(operation.variables),
      omitTypename
    );
  }

  return forward(operation);
});

function omitTypename(key, value) {
  return key === '__typename' ? undefined : value;
}

const link = from([omitTypenameLink, authLink, errorLink, httpLink]);

export const client = new ApolloClient({
  link,
  cache,
});
